import { createSlice } from '@reduxjs/toolkit';
import initialState from './initial-state';

const startPageSlice = createSlice({
    name: 'startPage',
    initialState: initialState(),
    reducers: {
        setStartPageConfigAction: (state, { payload }) => {
            state.config = payload.config;
            state.status = payload.status;
        },
        setStartPageConfigStatusAction: (state, { payload }) => {
            state.status = payload.status;
        },
        setTrendingBrandsAction: (state, { payload }) => {
            state.trendingBrands.items = payload.items;
            state.trendingBrands.status = payload.status;
        },
        setTrendingBrandsStatusAction: (state, { payload }) => {
            state.trendingBrands.status = payload.status;
        },
        setTrendingSearchesAction: (state, { payload }) => {
            state.trendingSearches.items = payload.items;
            state.trendingSearches.status = payload.status;
        },
        setTrendingSearchesStatusAction: (state, { payload }) => {
            state.trendingSearches.status = payload.status;
        },
        setWishListAction: (state, { payload }) => {
            state.wishList.itemIds = payload.itemIds;
            state.wishList.status = payload.status;
        },
        setWishListStatusAction: (state, { payload }) => {
            state.wishList.status = payload.status;
        }
    }
});

export const {
    setStartPageConfigAction,
    setStartPageConfigStatusAction,
    setTrendingBrandsAction,
    setTrendingBrandsStatusAction,
    setTrendingSearchesAction,
    setTrendingSearchesStatusAction,
    setWishListAction,
    setWishListStatusAction
} = startPageSlice.actions;

export default startPageSlice.reducer;
